import { useParams } from 'react-router';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { ClientStatus } from '../../../model/ClientStatus';
import { getPripomienkyForSend } from '../../../client/sendPripomienkyClient';
import Pripomienka from '../../../model/pripomienka/Pripomienka';

interface ReturnType {
  pripomienkyForSend: Array<Pripomienka>;
  pripomienkaStatus: ClientStatus;
}

export default (): ReturnType => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const {
    data: pripomienkyForSend,
    status: pripomienkaStatus,
  } = useClientFetch(
    getPripomienkyForSend,
    [type, year, index],
    [],
  );
  return {
    pripomienkyForSend, pripomienkaStatus,
  };
};
